<template>
<div style="text-align: center">
  <h4 style="margin: 0;margin-bottom: 15px;font-size: 3.5vw;color: #dc1c1c;" id="goalBlinkWeek">{{ goals.week }} {{ goals.week_sum }} / {{ goals.month }} {{ goals.month_sum }}</h4>
  <monitorEmployeesRow :employees="monitorEmployees.regular"></monitorEmployeesRow>
  <div style="margin-bottom: 20px"></div>
  <monitorEmployeesRow :employees="monitorEmployees.intern"></monitorEmployeesRow>
</div>
</template>

<script>
/* eslint-disable */
import MonitorEmployeesRow from "../../components/monitor/MonitorEmployeesRow.vue"
import monitorHTTP from '@/api/modules/monitor/monitor'

export default {
  components: {
    monitorEmployeesRow: MonitorEmployeesRow
  },
  data() {
    return {
      errors: {},
      monitorEmployees: {
        'regular': [],
        'intern': []
      },
      goals: {
        month: '',
				week: '',
				month_sum: 0,
        week_sum: 0
			},
			month: '',
      API_URL: '',
      API_TOKEN: '',
      quotas: {}
    };
  },
  computed: {
    /* quotas() {
      return this.$store.getters.quotas;
    }, */
  },
  methods: {
    secondsToTime(seconds) {
      var sec_num = parseInt(seconds, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}
      return hours+':'+minutes+':'+seconds;
    },
    getDataInterval() {
      setInterval(() => {
        this.getData();
      }, 65000);
    },
    getData() {
      monitorHTTP.getQuotas().then((response) => {
        this.quotas = response;
        //this.quotas = response.body;
      }, function (response) {
      });

      monitorHTTP.getData().then((response) => {
        //let data = response.body;
        let data = response;

        this.monitorEmployees = {
          'regular': [],
          'intern': []
        };

        function formatCurrency(value) {
          let val = (value/1).toFixed(0).replace('.', ',');
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }

        this.goals.month_sum = formatCurrency(data.goals.month_sum);
        this.goals.week_sum = formatCurrency(data.goals.week_sum);
				this.goals.week = data.goals.week;
        this.goals.month = data.goals.month;
        //this.goals.year = '8.261.228';
        //this.goals.year = '8.279.128';

        //Для подсчета текущего лидера(у кого больше общий процент)
        let currentLeader = {
          'regular': {
            employeeId: 0,
            totalPercent: 0,
          },
          'intern': {
            employeeId: 0,
            totalPercent: 0,
          }
        }

        data['employees'].forEach((employeeData, employeeDataIndex) => {
          let employeeQuotas = 0;

          //Ищем индивидуальную квоту для сотрудника
          this.quotas.forEach(quota => {
            if(quota.employeeId == employeeData.info.id) {
              employeeQuotas = quota.quotas;
              return true;
            }
          });

          let statisticsPercent = {
            calls:
                parseInt(((employeeData.statistics.calls.today.countSum * 100) /
                    employeeQuotas.calls.countSum).toFixed(1)),
            deals:
                parseInt(((employeeData.statistics.deals.today.priceSum * 100) /
                    employeeQuotas.deals.priceSum).toFixed(1)),
            invoices:
                parseInt(((employeeData.statistics.invoices.today.priceSum * 100) /
                    employeeQuotas.invoices.priceSum).toFixed(1)),
          };

          //Все значения приводим до 100. Нужно чтобы посчитать общий процент
          let sumPercent = 0;
          let statisticPercent = 0;
          let statisticPercentCount = 0;
          for (const property in statisticsPercent) {
            statisticPercent = 100;
            if (statisticsPercent[property] < 100) {statisticPercent = statisticsPercent[property];}
            sumPercent += statisticPercent;
            statisticPercentCount++;
          }
          let totalPercent = parseInt(sumPercent / statisticPercentCount).toFixed(1);

          //Добавляем инфо сотрудника в итоговый массив
          this.monitorEmployees[employeeData.info.type].push({
            info: employeeData.info,
            statistics: {
              percent: {
                calls: statisticsPercent.calls,
                deals: statisticsPercent.deals,
                invoices: statisticsPercent.invoices,
                total: totalPercent
              },
              raw: employeeData.statistics,
              callsDurationTime: this.secondsToTime(employeeData.statistics.calls.today.durationSum),//небольшой костыль, а то хз куда еще это записывать
              leader: false
            }
          });

          //Добавляем самый большой процент
          if(parseInt(totalPercent) > parseInt(currentLeader[employeeData.info.type].totalPercent)) {
            currentLeader[employeeData.info.type] = {
              employeeId: employeeData.info.id,
              totalPercent: totalPercent
            };
          }
        });

        //Определяем того у кого самый большой процент
        Object.keys(currentLeader).forEach(type => {
          this.monitorEmployees[type].forEach(employee => {
            if(employee.info.id == currentLeader[type].employeeId) {
              employee.statistics.leader = true;
              return true;
            }
          });
        });
      })
      .catch(e => {
        this.errors = e;
      });

    }
  },
  mounted() {
    this.getDataInterval()
  },
  created() {
		this.getData()
  },
  beforeDestroy () {
    // clearInterval(this.getDataInterval)
  },
}
</script>

<style lang="scss">
  @function assetsPath($path) {
    @return "/static/img/#{$path}";
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 0 30px;
  }
  //Ебал в рот как добавлять картинки в файлы scss. Выдает ошибку cant resolve
  .statisticEmployeeName {
    &_leader::after {
      background-image: url(assetsPath('icons/crown.png'));
    }
  }
  .progressBar {
    &_icon_phone::before {
      background-image: url(assetsPath('icons/phone.png'));
    }
    &_icon_email::before {
      background-image: url(assetsPath('icons/email.png'));
    }
    &_icon_coins::before {
      background-image: url(assetsPath('icons/coins.png'));
    }
  }

  .statisticEmployeeCard {
    &__nameInfo {
      text-align: center;
      font-size: 2vw;
      font-weight: 600;
      color: #333;
    }
    &__progressBarWrapper {
      margin-bottom: 7px;
    }
    &__dataRow {
      margin-bottom: 10px;
			font-size: 1.5vw;
    }
  }
  .statisticEmployeeCardList {
    &__wrapper {
			/*
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: -20px -30px;
      */
    }
    &__item {


      background: #fff;
      padding: 15px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      border-radius: 5px;
    }
  }

  .progressBarWrapper {
    &__label {
      margin-bottom: 3px;
      font-size: 1.5vw;
      color: #000000;
    }
  }

  .progressBar {
  	width: 300px !important;
    background-color: transparent !important;

    &_theme_default svg {
      border-radius: 7px;
    }
    &_color_success line:nth-child(2){
      stroke: #38e041;
    }
    &_color_fail line:nth-child(2) {
      //stroke: #D9534F;
      //stroke: #ec120c;
      stroke: #f77572;
    }
    &_color_normal line:nth-child(2) {
      stroke: #f8f906;
    }
    &_icon::before {
      content: '';
      display: inline-block;
      width: 21px;
      height: 20px;
      position: relative;
      background-repeat: no-repeat;
      background-size: 100%;
      top: 6px;
      left: 0px;
    }
    &_icon_phone::before {

    }
  }

  .radialChart {
    &_center {
      .apexcharts-canvas {
        margin: auto;
      }
    }
    .apexcharts-datalabel-value {
      fill: #868282;
      font-weight: bold;
    }
    .apexcharts-radialbar-track path {
      stroke: #f1f1f1;
    }

  }

  .statisticEmployeeName {
    position: relative;
    display: inline-block;
    &_leader::after {
      content: "";
      width: 50px;
      height: 60px;
      background-repeat: no-repeat;
      background-size: 50px;
      background-position: right;
      display: block;
      position: absolute;
      top: -18px;
      right: -24px;
      transform: rotate(21deg);
    }
  }

  #goalBlinkWeek {
    -webkit-animation: goalBlinkWeek 2s linear infinite;
    animation: goalBlinkWeek 2s linear infinite;
		text-transform: uppercase;
  }
  @-webkit-keyframes goalBlinkWeek {
    100% { color: rgba(28, 79, 220, 1); }
    50% { color: rgba(183, 37, 37, 0.3); }
    100% { color: rgba(28, 79, 220, 1); }
  }
  @keyframes goalBlinkWeek {
    100% { color: rgba(28, 79, 220, 1); }
    50% { color: rgba(183, 37, 37, 0.3); }
    100% { color: rgba(28, 79, 220, 1); }
  }

    #goalBlink {
    -webkit-animation: goalBlink 2s linear infinite;
    animation: goalBlink 2s linear infinite;
		text-transform: uppercase;
  }
  @-webkit-keyframes goalBlink {
    100% { color: rgba(220, 28, 28, 1); }
    50% { color: rgba(183, 37, 37, 0.3); }
    100% { color: rgba(220, 28, 28, 1); }
  }
  @keyframes goalBlink {
    100% { color: rgba(220, 28, 28, 1); }
    50% { color: rgba(183, 37, 37, 0.3); }
    100% { color: rgba(220, 28, 28, 1); }
  }

	@media screen and (max-width: 320px) {
		.progressBar {
			width: 237px !important;
		}
		.statisticEmployeeCardList {
			&__item {
				width: 288px;
			}
		}
	}

	@media screen and (max-width: 576px) {
		.progressBarWrapper {
			&__label {
				font-size: 4vw;
			}
		}
		.statisticEmployeeCard {
			&__nameInfo {
				font-size: 4vw;
			}
			&__dataRow {
				font-size: 4vw;
			}
		}
	}



	/*
	#goalBlink {
		-webkit-animation: goalBlink 2s linear infinite;
		animation: goalBlink 2s linear infinite;
	}
	@-webkit-keyframes goalBlink {
		0% { color: rgb(128, 0, 0); }
		50% { color: rgb(183, 65, 14); }
		100% { color: rgb(128, 0, 0); }
	}
	@keyframes goalBlink {
		0% { color: rgb(128, 0, 0); }
		50% { color: rgb(183, 65, 14); }
		100% { color: rgb(128, 0, 0); }
	}*/
</style>



// WEBPACK FOOTER //
// src/pages/monitor/index.vue